module.exports = __webpack_public_path__ + "static/media/master.57770af7.svg";